import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

/** Tags the document for native-specific CSS; system bars are handled by the OS WebView layout. */
@Injectable({ providedIn: 'root' })
export class SafeAreaService {
  private started = false;

  start(): void {
    if (this.started || typeof document === 'undefined') {
      return;
    }
    this.started = true;

    const platform = Capacitor.getPlatform();
    document.body.classList.add('capacitor-native');
    document.body.classList.add(`capacitor-${platform}`);
  }
}
